import { styled } from 'styled-components';

import ArrowSVG from '../assets/arrow-in-circle.svg?react';

export const CircleArrowIcon = styled(ArrowSVG)`
  width: 24px;
  height: 24px;
`;
